import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import type { App } from 'vue'

// Pinia + persistence plugin installed but NO stores defined here (contract 01 §7).
// Features opt into persistence per-store; sensitive keys use secure-ls as their
// storage backend at the store level.
export function installPinia(app: App): void {
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  app.use(pinia)
}
